import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from '@material-ui/core/Button';

import Config from '../../constants/appConfig';
import MaterialIcon from './../../components/MaterialIcon';
import TextField from '@material-ui/core/TextField';
import SearchIcon from "@material-ui/icons/Search";
import Edit from './Edit';
import Names from './Names';

import { notification } from 'antd';

class EnhancedTableHead extends React.Component {

  columnData = [
    { id: 'action', disablePadding: true, label: '' },
    { id: 'blank', key: 'blank-spacer', disablePadding: true, label: '' },
    { id: 'cnpj', disablePadding: true, label: this.props.res.CPFCNPJ },
    { id: 'company_name', disablePadding: true, label: this.props.res.EMPRESA },
    { id: 'status', disablePadding: true, label: this.props.res.STATUS },
    { id: 'client_name', disablePadding: true, label: this.props.res.NOME_CLIENTE },
    { id: 'blank', key: 'blank-add-names', disablePadding: true, label: '' },
    { id: 'alter_name', disablePadding: true, label: this.props.res.NOMES_ALTERNATIVOS },

  ];

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
          </TableCell>
          {this.columnData.map(column => {
            return (
              <TableCell
                key={column.key || column.id}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title="Sort"
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing(),
  },
  highlight: {
    color: '#6c76ff',
    backgroundColor: '#d7d9e0',
  },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes, handleChange, filtro, clear, link, res } = props;

  const limpaCampo = () => {
    document.getElementById('campoFiltro').value = '';
    clear();
  }

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        <Typography component={'span'} id="tableTitle">
          <h1>{res.COMPARTILHAMENTO} - {res.CLIENTE}</h1>
        </Typography>
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        <div style={{ width: '14rem' }}>
          <SearchIcon style={{ marginRight: '.5rem', marginTop: '1.5rem' }} />
          <TextField
            placeholder="Filtro"
            margin="normal"
            onChange={handleChange('filtro')}
            id="campoFiltro"
          />
          {(filtro === '') ? <div></div> :
            <IconButton style={{ position: 'absolute', marginTop: '.5rem', right: '3rem', cursor: 'pointer' }} onClick={() => limpaCampo()}>
              <MaterialIcon icon="clear" />
            </IconButton>
          }
        </div>
      </div>
      <div className={classes.actions}>
        <Tooltip title="Add">
          <IconButton aria-label="Add" onClick={event => { link() }} >
            <AddIcon />
          </IconButton>
        </Tooltip>
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  table: {
    minWidth: 600,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
});

class EnhancedTable extends React.Component {
  state = {
    order: 'asc',
    orderBy: 'usuarios',
    selected: [],
    data: [],
    newValues: {},
    addNames: false,
    edit: false,
    id: null,
    page: 0,
    rowsPerPage: 10,
    error: null,
    filtro: '',
    sel_id: null,
  };

  componentDidMount() {
    this.updateList();
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  onCloseEdit = () => {
    this.updateList();
    this.setState({ edit: false, id: null });

  };
  showEdit = (id) => {
    this.setState({ edit: true, id: id });
  };
  onCloseAddNames = () => {
    this.updateList();
    this.setState({ addNames: false, newValues: {} });
  };

  getSorting(order, orderBy) {
    return order === 'desc'
      ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
      : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  clear = () => {
    this.setState({
      filtro: ''
    });
  };

  updateList = () => {
    const apiUrl = Config.server + '/company_link/allclient';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            data: result
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      )
  };

  update = () => {
    const id = this.state.sel_id;
    const status = 'canceled';
    this.setState({ sel_id: null });

    const apiUrl = `${Config.server}/company_link/origin/${id}/${status}`;
    let obj = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };
    fetch(apiUrl, obj)
      .then((res) => {
        if (res.status !== 200) throw new Error(res.status);
        else return res.json();
      })
      .then((result) => {
        this.updateList();
      }, (error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          console.log(error);
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState(state => ({ selected: state.data.filter(item => {
                  return (
                    item.empresa_name?.toLowerCase().includes(this.state.filtro.toLowerCase()) ||
                    item.status?.toLowerCase().includes(this.state.filtro.toLowerCase()) ||
                    item.client_name?.toLowerCase().includes(this.state.filtro.toLowerCase()) ||
                    item.alter_name?.toLowerCase().includes(this.state.filtro.toLowerCase())
                  );
                }).map(n => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes, link, res } = this.props;
    const { data, order, orderBy, selected, rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    const deleteIcon = id => (
      <IconButton onClick={() => this.setState({ sel_id: id })} aria-label="Delete">
        <DeleteIcon color="secondary" />
      </IconButton>
    );

    const addIcon = (id, cnpj, name, name_cli, name_clis) => (
      <IconButton aria-label="Add" onClick={event => this.setState({ addNames: true, newValues: { id, cnpj, name, name_cli, name_clis } })} >
        <AddIcon />
      </IconButton>
    );

    return (
      <Paper className={classes.root}>
        <EnhancedTableToolbar numSelected={selected.length} deleteButton={this.deleteUser}
          filtro={this.state.filtro} handleChange={this.handleChange} clear={this.clear} link={this.showEdit} res={res} />
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle" style={{ tableLayout: 'auto' }}>

            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={data.length}
              res={res}
            />
            <TableBody>
              {data
                .filter(item => {
                  return (
                    item.empresa_name?.toLowerCase().includes(this.state.filtro.toLowerCase()) ||
                    item.status?.toLowerCase().includes(this.state.filtro.toLowerCase()) ||
                    item.client_name?.toLowerCase().includes(this.state.filtro.toLowerCase()) ||
                    item.alter_name?.toLowerCase().includes(this.state.filtro.toLowerCase())
                  );
                })
                .sort(this.getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((n, key) => {
                  const isSelected = this.isSelected(n.id);
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isSelected}
                      tabIndex={-1}
                      key={key}
                      selected={isSelected}
                    >
                      <TableCell className="check" padding="checkbox" style={{ height: '3rem' }}>
                      </TableCell>
                      <TableCell
                        className="coluna"
                        padding="checkbox"
                      >
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                          {n.status !== 'waiting' && deleteIcon(n.id)}
                        </div>
                      </TableCell>
                      <TableCell className="check" padding="checkbox" style={{ height: '3rem' }}>
                      </TableCell>
                      <TableCell component="th" scope="row" padding="none">{n.cnpj}</TableCell>
                      <TableCell component="th" scope="row" padding="none">{n.company_name}</TableCell>
                      <TableCell component="th" scope="row" padding="none">{res[n.status.toUpperCase()]}</TableCell>
                      <TableCell component="th" scope="row" padding="none">{n.client_name}</TableCell>
                      <TableCell
                        className="coluna"
                        padding="checkbox"
                      >
                        {n.status === 'accepted' &&
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            {addIcon(n.id, n.cnpj, n.company_name, n.client_name, n.alt_names)}
                          </div>
                        }
                      </TableCell>
                      <TableCell component="th" scope="row" padding="none">{n.alt_names?.join(', ')}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={9} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          component="div"
          count={data.filter(item => {
                  return (
                    item.empresa_name?.toLowerCase().includes(this.state.filtro.toLowerCase()) ||
                    item.status?.toLowerCase().includes(this.state.filtro.toLowerCase()) ||
                    item.client_name?.toLowerCase().includes(this.state.filtro.toLowerCase()) ||
                    item.alter_name?.toLowerCase().includes(this.state.filtro.toLowerCase())
                  );
                }).length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{ 'aria-label': 'Previous Page', }}
          nextIconButtonProps={{ 'aria-label': 'Next Page', }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
        <Dialog onClose={this.onCloseEdit} aria-labelledby="simple-dialog-title" open={this.state.edit}>
          <Edit res={res} onClose={this.onCloseEdit} id={this.state.id} />
        </Dialog>
        <Dialog onClose={this.onCloseAddNames} aria-labelledby="simple-dialog-title" open={this.state.addNames}>
          <Names res={res} onClose={this.onCloseAddNames} values={this.state.newValues} />
        </Dialog>
        <Dialog
          open={!!this.state.sel_id}
          onClose={() => this.setState({ sel_id: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {this.props.res.DESEJA_EXCLUIR_ITEM}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => this.update()} color="primary">
              {res.SIM}
            </Button>
            <Button onClick={() => this.setState({ sel_id: null })} color="primary" autoFocus>
              {res.NAO}
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }
}

const EnhancedTable1 = withStyles(styles)(EnhancedTable);

const Section = (props) => {
  const { link, res } = props;
  return (
    <div className="rowForm">
      <EnhancedTable1 link={link} res={res} />
    </div>)
}


export default Section;
